import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAppointment } from 'src/app/models/dashboard.models';

@Component({
  selector: 'generic-calendar',
  templateUrl: './generic-calendar.component.html',
  styleUrls: ['./generic-calendar.component.scss']
})
export class GenericCalendarComponent implements OnInit {

  @Input() initialDate: Date;

  @Input() appointmentDates:Array<IAppointment> = [];
  @Input() dueDates: Array<number> = [];

  @Output() dateSelected: EventEmitter<Date> = new EventEmitter();
  @Output() monthChange: EventEmitter<Date> = new EventEmitter();

  datesList:any;
  monthAndYear: any = '';
  loading: boolean = false;
  currentMonth: Date = new Date();
  selectedDate: Date = new Date();

  constructor(private datePipe: DatePipe) {}

  ngOnInit(): void {
    this.resetDateList();
    if(!this.initialDate){
      this.initialDate = new Date();
      this.initialDate.setDate(1);
      this.initialDate.setHours(0,0,0,0);
    }
    this.selectedDate.setHours(0,0,0,0);
    this.populateDateList();
  }

  resetDateList() {
    this.datesList = [
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined],
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined],
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined],
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined],
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined],
      [undefined, undefined, undefined, undefined, undefined, undefined, undefined]
    ]
  }

  populateDateList() {
    this.resetDateList();

    let currentDate = new Date(this.initialDate);
    let datesListIndex = 0;
    for(let date=0; date<31; date++){
      currentDate.setDate(this.initialDate.getDate() + date);
      if(currentDate.getMonth() === this.initialDate.getMonth()) {
        this.datesList[datesListIndex][currentDate.getDay()] = currentDate.getDate();
        if(currentDate.getDay() === 6) {
          datesListIndex += 1;
        }
      }
    }

    if(this.datesList[5][0] == undefined) {
      this.datesList.forEach((element:any, index:any)=>{
        if(index==5) this.datesList.splice(index, 1);
     });
    }
    this.loading = false;
  }

  getDateClasses(date?:number) {
    var classes = ['default-date-cell'];

    for(let i=0; i<this.appointmentDates.length; i++) {
      if(date === new Date(this.appointmentDates[i].date).getDate()) {
        
        if(classes[0] == 'default-date-cell')
        {
          classes[0] = 'highlighted-date-cell-1';
        }
        else if(classes[0] == 'highlighted-date-cell-1'){
          classes[0] = 'highlighted-date-cell-2';
        }
      }
    }

    this.currentMonth.setHours(0,0,0,0);
    if(date) this.currentMonth.setDate(date);
    for(let i=0; i<this.dueDates.length; i++) {
      if(this.currentMonth.getTime() === this.dueDates[i]) {
        classes[0] = 'highlighted-date-cell-3'
      }
      if(this.currentMonth.getTime() === this.selectedDate.getTime()) {
        classes[0] = classes[0] + ' active';
      }
    }

    return classes;
  }

  monthBack() {
    this.loading = true;
    this.initialDate.setDate(this.currentMonth.getDate() - 31);
    this.initialDate.setDate(1);
    this.initialDate = new Date(this.initialDate);
    this.currentMonth = this.initialDate;
    this.monthAndYear = this.datePipe.transform(this.initialDate,"MMMM y");
    this.monthChange.emit(this.monthAndYear);
  }

  monthForward() {
    this.loading = true;
    if(this.currentMonth.getMonth() == 0){
      this.initialDate.setDate(this.currentMonth.getDate() + 28);
    }
    else{
      this.initialDate.setDate(this.currentMonth.getDate() + 30);
    }
    this.initialDate.setDate(1);
    this.initialDate = new Date(this.initialDate);
    this.currentMonth = this.initialDate;
    this.monthAndYear = this.datePipe.transform(this.initialDate,"MMMM y");
    this.monthChange.emit(this.monthAndYear);
  }

  selectDate(date:any) {
    if(date) {
      this.selectedDate = new Date(this.initialDate);
      this.selectedDate.setDate(date);
      this.selectedDate.setHours(0,0,0,0);
      this.dateSelected.emit(this.selectedDate);
    }
  }

}
